import { IAppointment } from './appointment.type'
import { ICalls } from './calls.type'
import { IContact } from './contact.type'
import type { ProviderColor } from './provider.types'

export enum ChatChannel {
  sms = 'SMS',
  messenger = 'Messenger',
  instagram = 'Instagram',
  inApp = 'In-app',
}

export enum MetaChannel {
  messenger = 'Messenger',
  instagram = 'Instagram',
}

export enum ChatDirection {
  incoming = 'Incoming',
  outgoing = 'Outgoing',
  ai = 'AI',
}

export enum SendStatus {
  queued = 'queued',
  sent = 'sent',
  delivery_unknown = 'delivery_unknown',
  delivered = 'delivered',
  undelivered = 'undelivered',
  failed = 'failed',
}

export interface IPatient {
  patient_id: string
  photo: string
  first_name: string
  last_name: string
  cellphone: string
  last_active?: string
  email: string
  patient_status: number
  preferred_name: string
  meta_id?: string
  meta_username?: string
  date_of_birth?: string
  gender?: string
  public_id?: string
  appointments?: IAppointment[]
}

export interface IProvider {
  provider_id: string
  first_name: string
  last_name: string
  cellphone: string
  public_id?: string
  work_status?: string
}

export interface IChatParticipantProviderProfile {
  first_name: string
  middle_name?: string
  last_name: string
  photo?: string | null
  provider_color?: ProviderColor | string | null
  work_role?: string | null
}

export interface IChatParticipantUser {
  user_id: string
  first_name: string
  middle_name?: string
  last_name: string
  email_address?: string | null
  contact_number?: string | null
  username?: string
  role?: string
  provider_profile?: IChatParticipantProviderProfile | null
}

export interface IChatMessage {
  chat_message_id?: string
  chat_conversation_id: string
  external_id?: string
  sender_id: string
  receiver_id: string
  chat_direction: ChatDirection
  channel?: 'In-app' | 'Meta' | 'SMS'
  send_status?: SendStatus
  timestamp: string
  content: string
  html_content: string
  is_edited?: boolean
  is_deleted?: boolean
  is_pinned?: boolean
  is_read?: boolean
  call_sid?: string

  sender?: { first_name?: string; middle_name?: string; last_name?: string }
  calls?: Partial<ICalls>
}

export interface IChatParticipant {
  chat_participant_id?: string
  chat_conversation_id: string
  meta_channel?: MetaChannel
  phone_number?: string
  contact_id?: string
  user_id?: string
  username?: string
  photo?: string
  last_active?: string
  last_read_at?: string | null
  last_deleted_at?: string | null
  is_active?: boolean

  contact?: IContact
  user?: IChatParticipantUser | null
}

export type ConversationType = 'Internal' | 'External'

export type ConversationKind = 'group' | 'personal'

export interface IChatConversation {
  chat_conversation_id?: string
  name?: string
  channel: ChatChannel
  is_archived?: boolean
  is_pinned?: boolean
  is_hidden?: boolean
  chat_type?: ConversationType
  conversation_kind?: ConversationKind
  clinic_number_id?: string | null
  assigned_team?: string | null
  assigned_at?: Date | string | null
  clinic_number?: {
    clinic_number_id?: string
    phone_number?: string
    line_name?: string | null
    is_main?: boolean
  }
  date_time_created_at?: Date | string
  date_time_updated_at?: Date | string
  date_time_archived_at?: Date | string | null
  chat_message: IChatMessage[]
  chat_participant: IChatParticipant[]
}
